import { Injectable } from "@angular/core";
import { IUser } from "../api-generated";
import BaseService from "./base.service";

@Injectable({
  providedIn: "root",
})
export default class LocalUserService extends BaseService<IUser> {
  public getUserById(userId: string): IUser | undefined {
    return this.getItems().find((user: IUser) => {
      return user.id == userId;
    });
  }
}
